import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { ETransportType } from '../../../common/types';
import Companies, { CompaniesProps } from '../../../components/Companies';
import { PROVIDERS_LOGOS } from '../../../helpers/constants';
import { NAVIGATION } from '../../App/constants';
import messages from './messages';

const PATHNAME_TO_TRANSPORT_TYPE = {
  [`${NAVIGATION.COMPANY}/${ETransportType.TRAIN}`]: ETransportType.TRAIN,
  [`${NAVIGATION.COMPANY}/${ETransportType.BUS}`]: ETransportType.BUS,
  [`${NAVIGATION.COMPANY}/${ETransportType.CARPOOLING}`]:
    ETransportType.CARPOOLING,
};

const TRANSPORT_TYPE_IMAGES: Record<string, CompaniesProps['images']> = {
  [ETransportType.TRAIN]: [
    {
      image: PROVIDERS_LOGOS['eurostar'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/eurostar`,
    },
    {
      image: PROVIDERS_LOGOS['voyages sncf'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/sncf`,
    },

    {
      image: PROVIDERS_LOGOS['renfe'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/renfe`,
    },
    {
      image: PROVIDERS_LOGOS['trenitalia'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/trenitalia`,
    },
    {
      image: PROVIDERS_LOGOS['sbb'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/sbb`,
    },

    {
      image: PROVIDERS_LOGOS['iryo'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/iryo`,
    },
    {
      image: PROVIDERS_LOGOS['thalys'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/thalys`,
    },
    {
      image: PROVIDERS_LOGOS['flixtrain'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/flixtrain`,
    },
    {
      image: PROVIDERS_LOGOS['italo treno'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/italo-treno`,
    },
    {
      image: PROVIDERS_LOGOS['obb'].src,
      linkUrl: `${NAVIGATION.COMPANY}/train/train-de-nuit/obb-train-de-nuit`,
    },
  ],
  [ETransportType.BUS]: [
    {
      image: PROVIDERS_LOGOS['bus blablacar'].src,
      linkUrl: `${NAVIGATION.COMPANY}/carpooling/blablacar/blablabus`,
    },
    {
      image: PROVIDERS_LOGOS['flixbus'].src,
      linkUrl: `${NAVIGATION.COMPANY}/bus/flixbus`,
    },
    {
      image: PROVIDERS_LOGOS['altibus'].src,
      linkUrl: `${NAVIGATION.COMPANY}/shuttle/ski/altibus`,
    },
    {
      image: PROVIDERS_LOGOS['alsa'].src,
      linkUrl: `${NAVIGATION.COMPANY}/bus/alsa`,
    },
    {
      image: PROVIDERS_LOGOS['itabus'].src,
      linkUrl: `${NAVIGATION.COMPANY}/bus/itabus`,
    },
    {
      image: PROVIDERS_LOGOS['marinobus'].src,
      linkUrl: `${NAVIGATION.COMPANY}/bus/marinobus`,
    },
  ],
  [ETransportType.CARPOOLING]: [
    {
      image: PROVIDERS_LOGOS['blablacar'].src,
      linkUrl: `${NAVIGATION.COMPANY}/carpooling/blablacar`,
    },
  ],
};

type CompanyPageTitleProps = {
  pathname: string;
  intl: any;
};

const CompanyPageTitle = (props: CompanyPageTitleProps) => {
  const { intl, pathname } = props;

  const titleTransportType = PATHNAME_TO_TRANSPORT_TYPE[pathname];

  if (!titleTransportType) {
    return null;
  }

  const transportTypeMessage = intl.formatMessage(
    messages[`plural-${titleTransportType}`],
  );

  return (
    <Companies
      images={TRANSPORT_TYPE_IMAGES[titleTransportType]}
      stopAnimatedCards={titleTransportType === ETransportType.CARPOOLING}
      subtitle={
        <FormattedMessage
          {...messages.companyPageSubtitle}
          values={{
            transportType: transportTypeMessage,
          }}
        />
      }
      testid="companyPageTitle"
      title={
        <FormattedHTMLMessage
          {...messages.companyPageTitle}
          values={{
            transportType: transportTypeMessage,
          }}
        />
      }
    />
  );
};

export const CompanyPageTitleIntl = injectIntl(CompanyPageTitle);
